import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import { Redirect, Link } from 'react-router-dom';
import { useFirestore } from 'react-redux-firebase';
import { InfiniteScroll } from '../general/InfiniteScroll';

const PRIZES_THAT_FIT_SCREEN = 15;

const Prizes = (props) => {
  const { auth } = props;
  const firestore = useFirestore();
  const query = useRef(firestore.collection('prizes'));
  const latestDoc = useRef(null);
  const [prizes, setPrizes] = useState([]);
  const [loadingMore, setLoadingMore] = useState(false);
  const [noMoreResults, setNoMoreResults] = useState(false);

  useEffect(() => getNextResults(true), []);

  const getNextResults = (fromScratch = false) => {
    query.current
      .orderBy('id')
      .startAfter(latestDoc.current || 0)
      .limit(PRIZES_THAT_FIT_SCREEN)
      .get()
      .then((snapshot) => {
        if (snapshot.empty) 
          setNoMoreResults(true);
        const nextPrizes = [];
        snapshot.forEach((doc) => {
          nextPrizes.push({ id: doc.id, ...doc.data() });
        });
        setPrizes(prizes => fromScratch ? nextPrizes : [...prizes, ...nextPrizes]);
        latestDoc.current = snapshot.docs[snapshot.docs.length - 1];
        setLoadingMore(false);
      })
      .catch((error) => console.log(error));
  };

  const loadNextResults = () => {
    if (!loadingMore) {
      setLoadingMore(true);
      getNextResults();
    }
  };

  const renderLoadingMore = () => loadingMore && <h5 style={{ textAlign: 'center' }}>Loading more...</h5>;

  const renderPrizes = () => {
    if (prizes) {
      return (
        <div className="row">
          <div>{prizes.map((p) => prize(p))}</div>
        </div>
      );
    }
  };

  const prize = (prize) => (
    <div className="row" key={prize.number} style={{ backgroundColor: '#f8f8f8', padding: 10, marginBottom: 5 }}>
      <div className="col s4">{prize.number}</div>
      <div className="col s4">{prize.type}</div>
      <div className="col s4">{prize.value}</div>
    </div>
  );

  if (!auth.uid) return <Redirect to="/signin" />;
  return (
    <div className="dashboard container">
      <div className="title-section">Prizes</div>
      <InfiniteScroll hasMoreData={!noMoreResults} isLoading={loadingMore} onBottomHit={loadNextResults} loadOnMount={true}>
        <div className="row">{renderPrizes()}</div>
      </InfiniteScroll>
      {renderLoadingMore()}
      <Link className="btn-floating btn-large fixed-action-btn green right" to="level">
        <i className="material-icons">add</i>
      </Link>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps), firestoreConnect([]))(Prizes);
